import type { ListProps } from 'react-window';
import { List } from 'react-window';

export function VirtualisedList<T extends object>({
  rowCount,
  rowHeight,
  rowProps,
  rowComponent,
  ...rest
}: ListProps<T>) {
  return <List rowComponent={rowComponent} rowCount={rowCount} rowHeight={rowHeight} rowProps={rowProps} {...rest} />;
}
